module.exports = __webpack_public_path__ + "img/zt-img4.9d66857b.png";